
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconParagraphLeftAlign = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M22.5 23.271h-21a1.25 1.25 0 010-2.5h21a1.25 1.25 0 010 2.5zM19.637 3.225H1.5a1.25 1.25 0 010-2.5h18.137a1.25 1.25 0 010 2.5zM15.818 9.907H1.5a1.25 1.25 0 010-2.5h14.318a1.25 1.25 0 110 2.5zM18.682 16.589H1.5a1.25 1.25 0 110-2.5h17.182a1.25 1.25 0 010 2.5z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M.5 22.998a.5.5 0 010-1h23a.5.5 0 010 1H.5zM.5 2.998a.5.5 0 010-1h20a.5.5 0 010 1H.5zM.5 7.998a.5.5 0 010-1h16a.5.5 0 010 1H.5zM.5 12.998a.5.5 0 010-1h23a.5.5 0 010 1H.5zM.5 17.998a.5.5 0 010-1h19a.5.5 0 010 1H.5z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M.75 3.748a.75.75 0 010-1.5h21a.75.75 0 010 1.5h-21zM.75 8.248a.75.75 0 010-1.5h18a.75.75 0 010 1.5h-18zM.75 12.748a.75.75 0 010-1.5h22.5a.75.75 0 010 1.5H.75zM.75 17.248a.75.75 0 010-1.5h18a.75.75 0 010 1.5h-18zM.75 21.748a.75.75 0 010-1.5h21a.75.75 0 010 1.5h-21z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconParagraphLeftAlign.displayName = 'IconParagraphLeftAlign';
export default IconParagraphLeftAlign;